module.exports = __webpack_public_path__ + "static/media/Grid.52380033.svg";